import { VscMenu } from "react-icons/vsc";

export default function MenuIcon({ size }) {
    return (
        <VscMenu size={size} />
    );
}